import http from './api';

const getChatUrl = () => http.get('api/reference-data/chatUrl');
const getSummaryView = cacheKey => http.get('api/reference-data/summary-view', { headers: { 'cache-key': cacheKey } });
const getSmtpDetails = () => http.get('api/reference-data/smtp-details');

export default {
  getChatUrl,
  getSummaryView,
  getSmtpDetails
};
